import React from 'react';
import { WarehouseOrderExtraServiceShowDataForm } from '../../../../../app/models/WareHouseOrderExtraService';

interface Props {
    extraServiceDataForm: WarehouseOrderExtraServiceShowDataForm;
}

const WarehouseOrderExtraServicesShowForm = ({
    extraServiceDataForm,
}: Props) => {

    return (
        <>
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Servicio Adicional</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        className="form-control"
                        name="service_name"
                        value={extraServiceDataForm.service }
                        readOnly
                    />
                </div>
            </div>
             <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Unidad</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        className="form-control"
                        name="unit"
                        value={extraServiceDataForm.unit|| ''}
                        readOnly
                    />
                </div>
            </div> 
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Tarifa</label>
                <div className="col-md-9">
                    <input
                        type="number"
                        className="form-control"
                        name="rate"
                        value={extraServiceDataForm.price || ''}
                        readOnly
                    />
                </div>
            </div> 
        </>
    );
};

export default WarehouseOrderExtraServicesShowForm;
